var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hideRegions,
              expression: "!hideRegions"
            }
          ]
        },
        [
          !_vm.hideFieldLabels
            ? _c("div", { staticClass: "ap-modal-input-name" }, [
                _vm._v("\n            Регион\n        ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("JHCustomSelect", {
            attrs: {
              selectOptions: _vm.optionsRegions,
              selectName: function(region, key) {
                return region.title_ru
              },
              selectableParamCondition: function(region, key) {
                return region.region_id
              },
              selectedParamValue: _vm.selectedParamValueRegion,
              visibleMessageLoading: _vm.waitingResponseToRegionRequest
            },
            on: { selected: _vm.selectRegion },
            model: {
              value: _vm.inputRegionName,
              callback: function($$v) {
                _vm.inputRegionName = $$v
              },
              expression: "inputRegionName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.hideFieldLabels
        ? _c("div", { staticClass: "ap-modal-input-name" }, [
            _vm._v("\n        Город\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("JHCustomSelect", {
        attrs: {
          selectOptions: _vm.optionsCities,
          selectName: function(city, key) {
            return city.title_ru
          },
          selectDescription: function(city, key) {
            return city.region_ru
          },
          selectableParamCondition: function(city, key) {
            return city.city_id
          },
          selectedParamValue: _vm.selectedParamValueCity,
          visibleMessageLoading: _vm.waitingResponseToCityRequest
        },
        on: {
          selected: _vm.selectCity,
          selectedName: _vm.selectName,
          scrollReachEnd: _vm.scrollReachEndCities,
          focusOnInput: _vm.updateCities
        },
        model: {
          value: _vm.inputCityName,
          callback: function($$v) {
            _vm.inputCityName = $$v
          },
          expression: "inputCityName"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }